export default "__VITE_ASSET__BYkkPSIL__"